import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-csr',
  templateUrl: './employee-csr.component.html',
  styleUrls: ['./employee-csr.component.css']
})
export class EmployeeCsrComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
